import React from 'react';

const FAQS = [
  {
    q: 'Is this really just ₹999?',
    a: 'Yes — a one-time fee for the full 4-hour session. No cross-selling, no pitch at the end. You attend and get your plan.',
  },
  {
    q: "I'm a final-year student, not hired yet. Is this for me?",
    a: 'Absolutely. The roadmap starts before your first job and maps your first 100 weeks, so you walk in with a plan from day one.',
  },
  {
    q: 'Is it online or in-person?',
    a: "Online and live with Chai. You'll get a joining link by email after you reserve your seat.",
  },
  {
    q: 'Do I need full-stack experience already?',
    a: 'No. This is built for freshers and early-career developers. We start from fundamentals and build the path from there.',
  },
  {
    q: 'What exactly do I walk away with?',
    a: 'A clear, week-by-week skill roadmap for your first ~2 years, the full-stack foundations that matter, and a realistic plan to become genuinely valuable fast.',
  },
];

export default function F2FFAQ() {
  return (
    <section className="f2f-faq-v2">
      <div className="wrap f2f-faq-v2-inner">
        <p className="f2f-faq-eyebrow">Questions</p>
        <h2 className="f2f-faq-heading">Before you register</h2>

        <div className="f2f-faq-list-v2">
          {FAQS.map((faq) => (
            <div key={faq.q} className="f2f-faq-row">
              <p className="f2f-faq-q">{faq.q}</p>
              <p className="f2f-faq-a">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
